var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDurham(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.96 67.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007853;}.cls-2{fill:#3e2b2f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dc-logos-2020-full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.72,3.52q0,4.55,0,9.11c0,3.89,0,7.78,0,11.68H35V3.52H54.72M58.24,0H31.43V27.83H58.25c0-8.88,0-17.76,0-26.64V0Z",
    transform: "translate(0.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.29,3.52V24.31H3.5c0-3.89,0-7.79,0-11.68,0-3,0-6.07,0-9.11H23.29M26.81,0H0V1.19Q0,14.51,0,27.83H26.81V0Z",
    transform: "translate(0.02)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.72,36l0,4.63a15.43,15.43,0,0,1-7.94,14.08C42.88,57,38.88,59.31,35,61.54V36H54.72m3.53-3.52H31.43V67.57c5.74-3.25,11.5-6.46,17.14-9.88a19,19,0,0,0,9.64-17.07c0-2.72,0-5.45,0-8.17Z",
    transform: "translate(0.02)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.29,36V61.54c-3.93-2.23-7.93-4.51-11.8-6.86A15.46,15.46,0,0,1,3.54,40.6c0-1.55,0-3.09,0-4.63H23.29m3.52-3.52H0l0,8.17A19.07,19.07,0,0,0,9.66,57.69c5.64,3.42,11.41,6.63,17.15,9.88V32.45Z",
    transform: "translate(0.02)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.2,2.72C80.89,0,77.58,0,74.92,0H68.8V20.59h6c2.94,0,5.49,0,7.54-1.71.8-.64,3.44-3.15,3.44-8.42A11.68,11.68,0,0,0,83.2,2.72ZM82,10.57c0,2.75-.83,4.76-2.45,6-1.26.94-3.22,1-5,1h-2.3V3.05h2.9c2.24,0,3.78.26,5,1.6C81.85,6.46,82,9.39,82,10.57Z",
    transform: "translate(0.02)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.29,0V12.55c0,1.43,0,5.24-5,5.24A5,5,0,0,1,94.1,16a5.28,5.28,0,0,1-.8-3.33V0H89.79V12.46c0,3.17.63,4.35,1.22,5.22,2.09,3,5.81,3.32,7.31,3.32a8.46,8.46,0,0,0,6.7-2.89,8.42,8.42,0,0,0,1.71-5.51V0Z",
    transform: "translate(0.02)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.86,20.07a25,25,0,0,1-1.2-6.06v-.08c-.23-2-.87-3.14-2.27-3.78a4.85,4.85,0,0,0,1.47-1,5.31,5.31,0,0,0,1.51-3.79A5,5,0,0,0,125,1a9.11,9.11,0,0,0-4.75-1h-7.47V20.59h3.48V11.64h3.07c3.15,0,3.65.68,4,3.37l0,.42a30.32,30.32,0,0,0,.88,4.89l.08.27H128Zm-11.68-17h4c1.76,0,3.57.33,3.57,2.82a2.45,2.45,0,0,1-1.15,2.25,5.44,5.44,0,0,1-2.42.39h-4Z",
    transform: "translate(0.02)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146,0V8.51h-8.65V0h-3.51V20.59h3.51V11.64H146v9h3.51V0Z",
    transform: "translate(0.02)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.71,0h-3.46l-8.66,20.59h3.66l2.14-5.16h8.68l2.15,5.16H174ZM167,12.43h-6.37c.33-.84,2.7-6.83,3.26-8.26C164.38,5.61,166.63,11.6,167,12.43Z",
    transform: "translate(0.02)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.56,0,189.1,15.54,183.76,0h-5.52V20.59h3.44V4.72l5.6,15.87h3.15s4.68-12.83,5.85-16V20.59h3.46V0Z",
    transform: "translate(0.02)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.74,
    y: 52.05,
    width: 130.98,
    height: 0.91
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.51,40.1A3.4,3.4,0,0,1,80.65,42a3.86,3.86,0,0,1-2.93,1.06c-3.46,0-5.21-2.48-5.21-7.38,0-2.91.68-7.8,5.24-7.8,3.41,0,3.78,2.31,3.89,3.07l.06.36h3.69l0-.41c-.35-4.41-4.11-6-7.5-6-6.68,0-9.06,5.57-9.06,10.79,0,2.43.63,10.37,8.7,10.37,3.31,0,7.34-1.54,7.8-5.86l0-.42H81.57Z",
    transform: "translate(0.02)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.7,24.66a9.17,9.17,0,0,0-6.89,2.78c-1.77,1.9-2.66,4.65-2.66,8.17,0,6.85,3.31,10.62,9.33,10.62s9.56-4,9.56-10.95C107,28.53,103.63,24.66,97.7,24.66Zm4,16.8a5.08,5.08,0,0,1-4.1,1.67,5,5,0,0,1-4.09-1.66,9.45,9.45,0,0,1-1.67-6c0-5.12,2-7.71,5.93-7.71,3.78,0,5.62,2.46,5.62,7.52C103.35,36.8,103.13,39.66,101.66,41.46Z",
    transform: "translate(0.02)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.13,42.56V25.18h-3.49V45.77h12.71V42.56Z",
    transform: "translate(0.02)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.1,42.56V25.18h-3.48V45.77h12.71V42.56Z",
    transform: "translate(0.02)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.75,42.58V36.77H158V33.69h-9.22V28.28h9.69v-3.1H145.23V45.77h13.42V42.58Z",
    transform: "translate(0.02)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.27,34.46v3h4.53v5.2a13.44,13.44,0,0,1-3.93.53c-2.25,0-3.93-.61-5-1.81-1.27-1.51-1.72-4.08-1.72-6a9.14,9.14,0,0,1,2-6.11,5.33,5.33,0,0,1,4.19-1.55c2.35,0,3.8,1,4.1,2.78l.05.32h3.73l0-.41a4.94,4.94,0,0,0-1.42-3.4,8.21,8.21,0,0,0-6.13-2.23A10.24,10.24,0,0,0,167,26.32c-4.1,2.75-4.42,8-4.42,9.49a10.94,10.94,0,0,0,2.88,7.81c1.7,1.74,4.14,2.59,7.46,2.59A21.91,21.91,0,0,0,180.05,45l.26-.09V34.46Z",
    transform: "translate(0.02)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190,42.58V36.77h9.22V33.69H190V28.28h9.68v-3.1h-13.2V45.77H200V42.58Z",
    transform: "translate(0.02)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.36,67.57c-2.29,0-2.72-1.35-2.63-2.88h1.85c0,.84,0,1.55,1.06,1.55a.88.88,0,0,0,.93-1c0-1.59-3.72-1.69-3.72-4.32,0-1.39.66-2.49,2.91-2.49,1.8,0,2.69.81,2.57,2.66h-1.8c0-.66-.11-1.34-.86-1.34a.86.86,0,0,0-1,1c0,1.67,3.72,1.53,3.72,4.31C74.44,67.3,72.77,67.57,71.36,67.57Z",
    transform: "translate(0.02)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.94,58.58v6.27c0,1.32-.75,2.72-3,2.72-2,0-3-1.06-3-2.72V58.58h1.85v6.15c0,1.09.46,1.51,1.14,1.51s1.17-.53,1.17-1.51V58.58Z",
    transform: "translate(0.02)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.81,63c0-2.34,0-4.57,3-4.57,1.88,0,2.64,1,2.57,2.94H91.62c0-1.18-.21-1.62-.76-1.62-1,0-1.18,1-1.18,3.25s.14,3.24,1.18,3.24c.85,0,.82-1.1.84-1.8h1.83c0,2.37-1,3.13-2.67,3.13C87.81,67.57,87.81,65.31,87.81,63Z",
    transform: "translate(0.02)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.06,63c0-2.34,0-4.57,3-4.57,1.89,0,2.65,1,2.57,2.94h-1.81c0-1.18-.21-1.62-.76-1.62-1,0-1.17,1-1.17,3.25s.13,3.24,1.17,3.24c.86,0,.82-1.1.85-1.8h1.82c0,2.37-.94,3.13-2.67,3.13C97.06,67.57,97.06,65.31,97.06,63Z",
    transform: "translate(0.02)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.4,67.42V58.58h4.83v1.36h-3v2.18H111v1.36h-2.74v2.58h3.07v1.36Z",
    transform: "translate(0.02)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.37,67.57c-2.29,0-2.72-1.35-2.62-2.88h1.85c0,.84,0,1.55,1.05,1.55a.88.88,0,0,0,.93-1c0-1.59-3.72-1.69-3.72-4.32,0-1.39.66-2.49,2.91-2.49,1.8,0,2.7.81,2.58,2.66h-1.8c0-.66-.11-1.34-.86-1.34a.87.87,0,0,0-1,1c0,1.67,3.73,1.53,3.73,4.31C120.46,67.3,118.78,67.57,117.37,67.57Z",
    transform: "translate(0.02)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.62,67.57c-2.29,0-2.71-1.35-2.62-2.88h1.85c0,.84,0,1.55,1.06,1.55a.88.88,0,0,0,.93-1c0-1.59-3.73-1.69-3.73-4.32,0-1.39.66-2.49,2.92-2.49,1.8,0,2.69.81,2.57,2.66h-1.8c0-.66-.11-1.34-.86-1.34a.86.86,0,0,0-1,1c0,1.67,3.72,1.53,3.72,4.31C129.71,67.3,128,67.57,126.62,67.57Z",
    transform: "translate(0.02)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.61,67.42V58.58h3l1.39,6h0l1.47-6h2.88v8.84h-1.8V60.6h0l-1.7,6.82h-1.76l-1.62-6.82h0v6.82Z",
    transform: "translate(0.02)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.12,67.42l2.45-8.84H155l2.4,8.84h-1.95l-.49-2h-2.52l-.5,2Zm3.57-7.14h0l-.84,3.82h1.76Z",
    transform: "translate(0.02)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.26,58.58v1.47H163.2v7.37h-1.85V60.05h-2V58.58Z",
    transform: "translate(0.02)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.83,58.58v1.47h-2.06v7.37h-1.85V60.05h-2.06V58.58Z",
    transform: "translate(0.02)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.13,67.42V58.58H182v1.36h-3v2.18h2.74v1.36H179v2.58h3.07v1.36Z",
    transform: "translate(0.02)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.51,67.42h-1.85V58.58h3.42c1.26,0,2.07.81,2.07,2.31a1.91,1.91,0,0,1-1.64,2.17v0a1.57,1.57,0,0,1,1.6,1.74,12.22,12.22,0,0,0,.21,2.6h-1.81a4,4,0,0,1-.2-1.71c0-1.06.1-1.95-1.32-1.95h-.48Zm0-5h.82c.74,0,.95-.74.95-1.3,0-.84-.36-1.16-.95-1.16h-.82Z",
    transform: "translate(0.02)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.62,67.57c-2.29,0-2.72-1.35-2.62-2.88h1.85c0,.84,0,1.55,1.05,1.55a.88.88,0,0,0,.93-1c0-1.59-3.72-1.69-3.72-4.32,0-1.39.66-2.49,2.91-2.49,1.8,0,2.7.81,2.58,2.66h-1.81c0-.66-.11-1.34-.85-1.34a.87.87,0,0,0-1,1c0,1.67,3.73,1.53,3.73,4.31C199.71,67.3,198,67.57,196.62,67.57Z",
    transform: "translate(0.02)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurham);
export default __webpack_public_path__ + "static/media/DURHAM.c5217519df991a1390f8e8792714fbcc.svg";
export { ForwardRef as ReactComponent };